import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import PeriodEndReportPage from './components/pdf/PeriodEndReportPage';
import PeriodEndReportDataPointsTable from './components/pdf/PeriodEndReportDataPointsTable';
import SectionTitle from './components/pdf/SectionTitle';
import SubsectionTitle from './components/pdf/SubsectionTitle';
import theme from '../Pdf/components/theme';
import {
  PeriodEndReportFundOverviewDataPoint,
  PeriodEndReportSectionPageProps,
} from './types';

const styles = StyleSheet.create({
  capitalBalanceSubsectionTitle: {
    paddingBottom: theme.spacing(theme.spacingSizes.sm),
  },
  performanceSnapshotSubsectionTitle: {
    paddingTop: theme.spacing(theme.spacingSizes.lg),
    paddingBottom: theme.spacing(theme.spacingSizes.sm),
  },
});

type Props = PeriodEndReportSectionPageProps & {
  capitalBalanceDataPoints: Array<PeriodEndReportFundOverviewDataPoint>;
  performanceSnapshotDataPoints: Array<PeriodEndReportFundOverviewDataPoint>;
};

const CommitmentOverview: FC<Props> = ({
  capitalBalanceDataPoints,
  performanceSnapshotDataPoints,
  sectionNumber,
  ...rest
}) => {
  return (
    <PeriodEndReportPage
      {...rest}
      header={`0${sectionNumber} – Commitment overview`}
    >
      <SectionTitle sectionNumber={sectionNumber} title="Commitment overview" />
      <SubsectionTitle
        sectionNumber={sectionNumber}
        subsectionNumber={1}
        title="Capital balance"
        paddedTop
        style={styles.capitalBalanceSubsectionTitle}
      />
      <PeriodEndReportDataPointsTable dataPoints={capitalBalanceDataPoints} />
      <SubsectionTitle
        sectionNumber={sectionNumber}
        subsectionNumber={2}
        title="Performance snapshot"
        style={styles.performanceSnapshotSubsectionTitle}
      />
      <PeriodEndReportDataPointsTable
        dataPoints={performanceSnapshotDataPoints}
      />
    </PeriodEndReportPage>
  );
};

export default CommitmentOverview;
